import { useEffect } from "react";

// Makes the kiosk and the display board installable as their own full-screen apps:
//  - points the page's <link rel="manifest"> at this screen's own manifest (/api/queue/pwa/...),
//    so "Install" opens straight at this kiosk / display instead of at the staff login
//  - keeps the screen awake while it is showing (Screen Wake Lock), re-asked when the tab
//    becomes visible again, because browsers drop the lock when a tab is hidden.

export default function usePwaScreen(kind, slug, query = "") {
  useEffect(() => {
    if (!slug) return undefined;
    let link = document.querySelector('link[rel="manifest"]');
    const created = !link;
    if (created) {
      link = document.createElement("link");
      link.rel = "manifest";
      document.head.appendChild(link);
    }
    const previous = link.getAttribute("href");
    link.setAttribute("href", `/api/queue/pwa/${kind}/${slug}/manifest.webmanifest${query}`);
    return () => {
      if (created) link.remove();
      else if (previous) link.setAttribute("href", previous);
    };
  }, [kind, slug, query]);

  useEffect(() => {
    if (!("wakeLock" in navigator)) return undefined;
    let lock = null;
    let stopped = false;
    const ask = async () => {
      try {
        if (!stopped && document.visibilityState === "visible" && !lock) {
          lock = await navigator.wakeLock.request("screen");
          lock.addEventListener("release", () => { lock = null; });
        }
      } catch (e) { lock = null; /* not allowed right now (battery saver, no gesture): try again later */ }
    };
    ask();
    document.addEventListener("visibilitychange", ask);
    document.addEventListener("pointerdown", ask);
    return () => {
      stopped = true;
      document.removeEventListener("visibilitychange", ask);
      document.removeEventListener("pointerdown", ask);
      if (lock) lock.release().catch(() => {});
    };
  }, []);
}
